import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SignalFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.58C15.9 3.58 19.14 6.8 19.14 10.68C19.14 12.98 18 15.04 16.26 16.36L15.54 14.96C16.76 13.94 17.56 12.4 17.56 10.68C17.56 7.62 15.04 5.1 12 5.1C8.96 5.1 6.44 7.62 6.44 10.68C6.44 12.4 7.24 13.94 8.46 14.96L7.74 16.36C6 15.04 4.86 12.98 4.86 10.68C4.86 6.8 8.1 3.58 12 3.58ZM12 6.66C14.2 6.66 16.06 8.5 16.06 10.68C16.06 11.8 15.58 12.82 14.8 13.56L14.04 12.08C14.32 11.68 14.48 11.2 14.48 10.68C14.48 9.34 13.38 8.18 12 8.18C10.62 8.18 9.52 9.34 9.52 10.68C9.52 11.2 9.68 11.68 9.96 12.08L9.2 13.56C8.42 12.82 7.94 11.8 7.94 10.68C7.94 8.5 9.8 6.66 12 6.66ZM7.7 20L12 9.7L16.3 20H7.7Z" />
    </SvgIcon>
  );
});
